import React, { FC } from 'react';

interface BreadCrumbProps{
    enabled: boolean,
    label: string,
    showDelimeter:boolean,
    onClick: () => void,
    stepNumber: number,
    currentStep: number
}

const BreadCrumb: FC<BreadCrumbProps> = ({enabled, onClick, label, showDelimeter, stepNumber, currentStep}) => {
    const handleClick = (event:React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        onClick();
    }
    return (
        <div className="flex items-center">
            {enabled &&
                <button onClick={handleClick }
                   className={`ml-1 text-sm font-bold text-gray-700 hover:text-gray-900 bg-transparent
                   cursor-pointer border-0 bg-amber-300 breadcrumb-button
                   ${currentStep === stepNumber ? 'breadcrumb-button-selected' : ''}`}
                >{label}</button>
            }
            {!enabled && <span
                className="ml-1 text-sm font-medium text-gray-700">
                {label}
            </span>}
            {showDelimeter && <span className="ml-3 font-bold">|</span>}
        </div>
    );
};

export default BreadCrumb;
